export const Outline = [
    { index : 0, link : "data-structure", topic : "Data Structure"},
    { index : 1, link : "array", topic : "Array"},
    { index : 2, link : "1d-array", topic : "1D Array"},
    { index : 3, link : "2d-array", topic : "2D Array"},
    { index : 4, link : "linkedlist", topic : "Linked List"},
    { index : 5, link : "singly-linkedlist", topic : "Singly Linked List"},
    { index : 6, link : "doubly-linkedlist", topic : "Doubly Linked List"},
    { index : 7, link : "circular-singly-linkedlist", topic : "Circular Singly Linked List"},
    { index : 8, link : "circular-doubly-linkedlist", topic : "Circular Doubly Linked List"},
    { index : 9, link : "queue", topic : "Queue"},
    { index : 10, link : "priority-queue", topic : "Priority Queue"},
    { index : 11, link : "stack", topic : "Stack"},
    { index : 12, link : "time-complexity", topic : "Time Complexity"},
    { index : 13, link : "space-complexity", topic : "Space Complexity"},
    { index : 14, link : "recursion", topic : "Recursion"},
    { index : 15, link : "trees", topic : "Trees"},
    { index : 16, link : "binary-tree", topic : "Binary Tree"},
    { index : 17, link : "binary-search-tree", topic : "Binary Search Tree"},
    { index : 18, link : "avl-tree", topic : "AVL Tree"},
    { index : 19, link : "max-heap", topic : "Max Heap"},
    { index : 20, link : "min-heap", topic : "Min Heap"},
    { index : 21, link : "pre-order", topic : "Pre Order"},
    { index : 22, link : "in-order", topic : "In Order"},
    { index : 23, link : "post-order", topic : "Post Order"},
    { index : 24, link : "sorting", topic : "Sorting"},
    { index : 25, link : "bubble-sort", topic : "Bubble Sort"},
    { index : 26, link : "merge-sort", topic : "Merge Sort"},
    { index : 27, link : "quick-sort", topic : "Quick Sort"},
    { index : 28, link : "selection-sort", topic : "Selection Sort"},
    { index : 29, link : "insertion-sort", topic : "Insertion Sort"},
    { index : 30, link : "hashing", topic : "Hashing"},
    { index : 31, link : "graph", topic : "Graph"},
    { index : 32, link : "dfs", topic : "DFS"},
    { index : 33, link : "bfs", topic : "BFS"},
    { index : 34, link : "radix-sort", topic : "Radix Sort"},
    { index : 35, link : "adjacency-list", topic : "Adjacency List"},
    { index : 36, link : "adjacency-matrix", topic : "Adjacency Matrix"},
    { index : 37, link : "linear-probing", topic : "Linear Probing"},
    { index : 38, link : "quadratic-probing", topic : "Quadratic Probing"},
    { index : 39, link : "separate-chaining", topic : "Separate Chaining"},
];